<template>
  <div class="logistics-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.comlist_v6" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="filterForm.comlist_v1" placeholder="请输入快递单号" clearable />
        </el-form-item>
        <el-form-item label="物流公司">
          <el-input v-model="filterForm.comlist_v2" placeholder="请输入物流公司" clearable />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filterForm.mem_user" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="物流状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="已揽收" value="已揽收" />
            <el-option label="运输中" value="运输中" />
            <el-option label="派送中" value="派送中" />
            <el-option label="已签收" value="已签收" />
            <el-option label="退回中" value="退回中" />
            <el-option label="异常" value="异常" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 物流列表表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="logisticsList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="comlist_v6" label="订单号" min-width="220" show-overflow-tooltip />
        <el-table-column prop="comlist_v1" label="快递单号" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="express-no">{{ scope.row.comlist_v1 }}</span>
            <el-button
              v-if="scope.row.comlist_v1"
              type="text"
              size="mini"
              class="copy-btn"
              @click="handleCopy(scope.row.comlist_v1)"
            >复制</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v2" label="物流公司" width="120" />
        <el-table-column prop="sh_name" label="所属店铺" min-width="130" show-overflow-tooltip />
        <el-table-column prop="mem_user" label="手机号" width="130" />
        <el-table-column prop="comlist_v8" label="收件人" width="100" show-overflow-tooltip />
        <el-table-column prop="status" label="物流状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="getLogisticsStatusType(scope.row.status)" size="small">
              {{ scope.row.status || '—' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v3" label="发货时间" width="160" />
        <el-table-column prop="comlist_v11" label="签收时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.comlist_v11 || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next, jumper"
            :page-count="pages"
            background
            />
    </el-card>

    <!-- 物流详情弹窗 -->
    <el-dialog title="物流详情" :visible.sync="dialogVisible" width="70%">
      <div v-if="currentLogistics" class="logistics-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单号">{{ currentLogistics.comlist_v6 }}</el-descriptions-item>
          <el-descriptions-item label="快递单号">
            <span class="express-no">{{ currentLogistics.comlist_v1 }}</span>
            <el-button
              v-if="currentLogistics.comlist_v1"
              type="text"
              size="mini"
              class="copy-btn"
              @click="handleCopy(currentLogistics.comlist_v1)"
            >复制</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="物流公司">{{ currentLogistics.comlist_v2 || '—' }}</el-descriptions-item>
          <el-descriptions-item label="物流状态">
            <el-tag :type="getLogisticsStatusType(currentLogistics.status)" size="small">
              {{ currentLogistics.status || '—' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="所属店铺">{{ currentLogistics.sh_name || '—' }}</el-descriptions-item>
          <el-descriptions-item label="会员手机号">{{ currentLogistics.mem_user || '—' }}</el-descriptions-item>
          <el-descriptions-item label="收件人">{{ currentLogistics.comlist_v8 || '—' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentLogistics.comlist_v9 || '—' }}</el-descriptions-item>
          <el-descriptions-item label="收货地址" :span="2">
            {{ currentLogistics.comlist_v10 || '—' }}
          </el-descriptions-item>
          <el-descriptions-item label="发货时间">{{ currentLogistics.comlist_v3 || '—' }}</el-descriptions-item>
          <el-descriptions-item label="签收时间">{{ currentLogistics.comlist_v11 || '—' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 物流轨迹 -->
        <div class="trace-title">物流轨迹</div>
        <div v-if="traceList.length" class="trace-wrap">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in traceList"
              :key="index"
              :timestamp="item.time"
              placement="top"
              :type="index === 0 ? 'primary' : ''"
              size="normal"
            >
              <div class="trace-content" :class="{ 'trace-active': index === 0 }">
                {{ item.content || '—' }}
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div v-else class="trace-empty">暂无物流轨迹信息</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const ddRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'LogisticsList',
  data () {
    return {
      loading: false,
      logisticsList: [],
      filterForm: {
        status: '',
        mem_user: '',
        comlist_v1: '',
        comlist_v2: '',
        comlist_v6: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentLogistics: null,
      traceList: []
    }
  },
  mounted () {
    this.getLogisticsList()
  },
  methods: {
    // 获取物流列表
    async getLogisticsList () {
      this.loading = true
      try {
        // 构建请求参数
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          ...this.filterForm
        }
        // 移除空值参数（不传则返回所有数据）
        Object.keys(params).forEach(key => {
          const val = params[key]
          if (val === '' || val === null || val === undefined) {
            delete params[key]
          }
        })

        const response = await ddRequest.post(
          'https://api.gd.91comerp.com/rcadmin/kuaidi_list.php?a=kuaidiList',
          { ...params }
        )

        if (response.data.code === '0' || response.data.res) {
          this.logisticsList = response.data.res || []
          this.pages = response.data.pages || 0
          // 计算总条数（用于分页显示，根据 pages 和 pageSize 估算）
          this.total = this.pages * this.pageSize
        } else if (response.data.code === 1001) {
          this.$message.error('请先登录')
          this.logisticsList = []
          this.total = 0
        } else {
          this.$message.error(response.data.msg || '获取物流列表失败')
          this.logisticsList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求物流列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.logisticsList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch () {
      this.currentPage = 1
      this.getLogisticsList()
    },

    // 重置筛选条件
    handleReset () {
      this.filterForm = {
        status: '',
        mem_user: '',
        comlist_v1: '',
        comlist_v2: '',
        comlist_v6: ''
      }
      this.currentPage = 1
      this.getLogisticsList()
    },

    // 分页-每页数量变化
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getLogisticsList()
    },

    // 分页-当前页变化
    handleCurrentChange (val) {
      this.currentPage = val
      this.getLogisticsList()
    },

    // 查看物流详情
    handleViewDetail (row) {
      this.currentLogistics = row
      this.traceList = this.parseTrace(row.comlist_m4)
      this.dialogVisible = true
    },

    // 复制
    handleCopy (text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制：' + text)
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(input)
    },

    // 解析物流轨迹 JSON
    parseTrace (jsonStr) {
      if (!jsonStr) return []
      let obj = jsonStr
      if (typeof jsonStr === 'string') {
        try {
          obj = JSON.parse(jsonStr)
        } catch (e) {
          // 非标准 JSON，直接按文本展示
          return [{ time: '', content: jsonStr }]
        }
      }
      if (!obj) return []

      const rawList = Array.isArray(obj)
        ? obj
        : (obj.data || obj.list || obj.traces || obj.result || obj.Traces || [])

      if (!Array.isArray(rawList)) return []

      return rawList.map(item => ({
        time: item.time || item.ftime || item.acceptTime || item.context_time ||
              item.timeStr || item['时间'] || '',
        content: item.context || item.status || item.desc || item.remark ||
                 item.acceptStation || item['内容'] || item['描述'] || ''
      }))
    },

    // 物流状态样式
    getLogisticsStatusType (status) {
      if (!status) return 'info'
      const s = String(status)
      if (s.indexOf('签收') > -1) return 'success'
      if (s.indexOf('派送') > -1 || s.indexOf('运输') > -1 || s.indexOf('途中') > -1) return 'warning'
      if (s.indexOf('退回') > -1 || s.indexOf('拒收') > -1 ||
          s.indexOf('异常') > -1 || s.indexOf('失败') > -1) return 'danger'
      if (s.indexOf('揽收') > -1 || s.indexOf('发货') > -1) return ''
      return 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.money {
  color: #ee530c;
}

.logistics-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}

.express-no {
  color: #303133;
  font-family: Menlo, Consolas, monospace;
}

.copy-btn {
  margin-left: 6px;
  padding: 0;
}

.logistics-detail {
  .trace-title {
    margin: 20px 0 14px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    padding-left: 8px;
    border-left: 3px solid #409eff;
    line-height: 1;
  }

  .trace-wrap {
    max-height: 320px;
    overflow: auto;
    padding: 4px 12px 0;
    background-color: #fafbfc;
    border-radius: 4px;

    ::v-deep .el-timeline {
      padding-left: 4px;
    }
  }

  .trace-content {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;

    &.trace-active {
      color: #409eff;
      font-weight: 600;
    }
  }

  .trace-empty {
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
    color: #909399;
  }
}
</style>
